export default __webpack_public_path__ + "right-bg3878797.png";